import { FavouriteBulkExportItem } from "../../../favourites/types";
import { IsavedExportSettingsDTO } from "../../api";
import type { BulkExportFormat, IDimension } from "../../types";

export interface IBulkExportContextValue {
  state: IBulkExportContextState;
  actions: IBulkExportContextActions;
}

export interface IBulkExportContextState {
  format: BulkExportFormat;
  dimensions: IDimension[];
  dataSourceId?: number;
  savedExportSettingsId?: number;
  email?: string;
  tab: BulkExportTab;
  settingsWasModified: boolean;
  settingsModifiedForFavourites: boolean;
  showSaveNotification: boolean;
  actionAfterSaveCancel?: () => void;
  currentSavedSettings?: IsavedExportSettingsDTO;
  currentFavouriteSettings?: FavouriteBulkExportItem;
  defaultCalendarDimension?: IDimension;
  cubeId: string;
}

export enum BulkExportTab {
  New = 0,
  Saved = 1,
}

export interface IBulkExportContextActions {
  setDataSourceId: (id?: number) => void;
  setEmail: (email: string) => void;
  setFormat: (format: BulkExportFormat) => void;
  setDimension: (dimension: IDimension) => void;
  setSavedExportSettingsId: (payloadObj: { id?: number; dimensions?: IDimension[]; format: BulkExportFormat }) => void;
  setTab: (tab: number) => void;
  setDefaultDimensions: (payload?: any) => void;
  setSettingsWasModified: (state: boolean) => void;
  setShowSaveNotification: (state: boolean) => void;
  setActionAfterSaveCancel: (payload?: any) => void;
  setCurrentSavedSettings: (payload?: any) => void;
  setCurrentFavouriteSettings: (payload?: any) => void;
  setDimensionCurrentFavourite: (payload?: any) => void;
  setFormatCurrentFavourite: (payload?: any) => void;
  setSettingsModifiedForFavourites: (payload?: any) => void;
  setDefaultCalendarDimension: (payload?: any) => void;
  setCubeId: (payload?: any) => void;
}

// Local type, do not export from module
export interface IBulkExportReducerAction {
  type: keyof IBulkExportContextActions;
  payload: unknown;
}
